<div class="response-widget">
  <div
    class="title-area"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div class="title">
      {{ 'COMMUNICATIONS.RECIPIENT-RESPONSE-STATUS' | translate }}
    </div>
  </div>
  <div>
    <topo-pie-chart
      [width]="width"
      [height]="width"
      [chartType]="chartType"
      [data]="data"
      [showLegend]="showLegend"
      [showPercentage]="showPercentage"
      [showValues]="showValues"
      (select)="selected($event)"></topo-pie-chart>
  </div>
</div>
